import React, { useEffect, useState } from "react";
import ProfileIcon from "../../../assets/img/EventDashoardLogo/eventprofile.svg";
import { dashboardColors, theme } from "../../../themes/Theme";
import CreateEventProfile from "./CreateEventProfile";
import ProfileDetails from "./ProfileDetails";
import { getEventProfiles } from "../../../revampCRUD/eventProfile.curd";
import { errorToaster } from "../../../reusable/common";
import { APIStatusCode } from "../../../services/util";
import LoadingSpinner from "../../../revampComponents/Atom/Loading";

const EventProfile = () => {
    const [isApiLoading, setisApiLoading] = useState(false);
    const [initialProfiles, setInitialProfiles] = useState([]);

    const fetchEventProfiles = async () => {
        setisApiLoading(true);
        try {
            const res = await getEventProfiles();
            if (res.status === APIStatusCode.STATUS_CODE_SUCCESS) {
                setInitialProfiles(res.data.event_profiles || []);
            } else {
                throw new Error("Unexpected response from API");

            }
            setisApiLoading(false);
        } catch (err) {
            console.error(err);
            errorToaster(err?.message);
        }
    };

    useEffect(() => {
        fetchEventProfiles();
    }, []);

    return (
        <div className="manage_events_container">
            {isApiLoading ? (
                <LoadingSpinner />
            ) : (
                <>
                    {initialProfiles.length > 0 ? (
                        <ProfileDetails
                            initialProfiles={initialProfiles}
                            fetchEventProfiles={fetchEventProfiles}
                        />
                    ) : (
                        <CreateEventProfile fetchEventProfiles={fetchEventProfiles} />
                    )}
                </>
            )}

            <style>{`
      .manage_events_container {
        margin: 0 !important;
        border-radius: 0px;
        background-color: #fff;
        overflow: hidden;
      }
    `}</style>
        </div>
    );
};

export default EventProfile;
